/** The payment page's clocks. Tests pass shorter ones through the `timings` prop. */
export const PAY_TIMINGS = {
  /** How long the 3DS method frame gets before the attempt is continued. */
  methodWaitMs: 8000,
  /** Attempt poll while a 3DS step is open. */
  pollMs: 2000,
  /** Attempt poll while an authorized payment is being completed by the API. */
  authorizedPollMs: 5000,
  /** How long the page keeps watching an authorized payment. */
  authorizedWatchMs: 2 * 60 * 1000,
  /** After this the page stops polling and offers to check again. */
  challengeTimeoutMs: 10 * 60 * 1000,
};

/** What the API's 3DS result page posts to the payment page. A hint to poll, nothing more. */
export const COMPLETE_MESSAGE_TYPE = 'gc-pay-3ds-complete';
